import { useParams } from "react-router-dom";
import { KPluginEntityId } from "@WahooFitness/wsm-native/dist/esm/types/kc/KPluginEntityId";
import { useMemo } from "react";

function useEntityIdParam(): KPluginEntityId | null {
  const { entityId: rawEntityId } = useParams();
  return useMemo(() => {
    if (!rawEntityId) return null;
    try {
      return JSON.parse(
        Buffer.from(decodeURIComponent(rawEntityId), "base64").toString("utf-8")
      ) as KPluginEntityId;
    } catch {
      return null;
    }
  }, [rawEntityId]);
}

function encodeEntityId(entityId: KPluginEntityId): string {
  return encodeURIComponent(Buffer.from(JSON.stringify(entityId)).toString("base64"));
}

export { encodeEntityId, useEntityIdParam };
